import React, { useCallback, useLayoutEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import LoyaltyForm from '../me/LoyaltyForm';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
import { searchTypesEnum } from '../../constants/Enums';
import { Screens } from '../../constants/ScreenNames';

const LoyaltyModal = ({ navigation, route }) => {
  const { type, loyaltyItem, loyaltyAirList } = route.params;
  const { tKey } = useComponentTKey('LoyaltyForm');
  const { t } = useTranslation(i18nNS.me);
  const getTitle = useCallback(() => {
    if (loyaltyItem) {
      switch (type) {
        case searchTypesEnum.AIR:
          return t(tKey('EditLoyaltyAir'));
        case searchTypesEnum.CAR:
          return t(tKey('EditLoyaltyCar'));
        case searchTypesEnum.HOTEL:
          return t(tKey('EditLoyaltyHotel'));
        case searchTypesEnum.RAIL:
          return t(tKey('EditLoyaltyRail'));
      }
    } else {
      switch (type) {
        case searchTypesEnum.AIR:
          return t(tKey('AddLoyaltyAir'));
        case searchTypesEnum.CAR:
          return t(tKey('AddLoyaltyCar'));
        case searchTypesEnum.HOTEL:
          return t(tKey('AddLoyaltyHotel'));
        case searchTypesEnum.RAIL:
          return t(tKey('AddLoyaltyRail'));
      }
    }
  }, [type, loyaltyItem, t, tKey]);

  useLayoutEffect(() => {
    navigation.setOptions({
      title: getTitle(),
    });
  }, [type, getTitle, navigation]);

  const onSubmit = () => {
    navigation.navigate(Screens.Me);
  };

  return (
    <View style={styles.body}>
      <LoyaltyForm
        type={type}
        visible={true}
        loyaltyItem={loyaltyItem}
        loyaltyAirList={loyaltyAirList}
        onSubmit={onSubmit}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  body: {
    flex: 1,
    backgroundColor: 'white',
  },
});

export default LoyaltyModal;
